module.exports = __webpack_public_path__ + "img/mind_skeleton_time_10.2ac9fdbc.png";